module.exports = __webpack_public_path__ + "3a0a64887dcc1f64a078f59afd3c4aac.jpg";